var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8754 8.42109H14.7122L19.3551 2.55469C19.4512 2.43047 19.3645 2.25 19.2075 2.25H10.2192C10.1536 2.25 10.0903 2.28516 10.0575 2.34375L3.98482 12.832C3.91216 12.9563 4.00122 13.1133 4.14654 13.1133H8.23404L6.13872 21.4945C6.09419 21.6773 6.3145 21.8062 6.45044 21.675L20.0043 8.74219C20.1262 8.62734 20.0442 8.42109 19.8754 8.42109Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.5eab931f1a9bb37439d42fdf427e25b1.svg";
export { ForwardRef as ReactComponent };